module.exports = __webpack_public_path__ + "img/refund.073433e0.svg";